import { CONNECT, SETTINGS } from '../../constants';
import { Logger } from '../../../../../../modules/infra/observability/logger';
import {
  GET_MAILCHIMP_SETTINGS,
  GET_MAILCHIMP_SETTINGS_ERROR,
  SAVE_MAILCHIMP_SETTINGS,
  SET_MAILCHIMP_STATE,
} from '../constants';
import { fetchMailchimpSyncSettings } from '../actions';

export const setMailchimpConnectState = () => (dispatch) => {
  dispatch({
    type: SET_MAILCHIMP_STATE,
    payload: CONNECT,
  });
};

export const setMailchimpSettingsState = () => (dispatch) => {
  dispatch({
    type: SET_MAILCHIMP_STATE,
    payload: SETTINGS,
  });
};

export const setMailchimpSettings = settings => (dispatch) => {
  dispatch({
    type: SAVE_MAILCHIMP_SETTINGS,
    payload: settings || {},
  });
};

export const getMailchimpSettings = () => (dispatch) => {
  dispatch({
    type: GET_MAILCHIMP_SETTINGS,
  });
};

export const getMailchimpSettingsError = () => (dispatch) => {
  dispatch({
    type: GET_MAILCHIMP_SETTINGS_ERROR,
  });
};

export const fetchSettings = brandId => (dispatch) => {
  dispatch(getMailchimpSettings());

  return fetchMailchimpSyncSettings(brandId)
    .then((response) => {
      if (response.status === 'no_connection') {
        dispatch(setMailchimpConnectState());

        dispatch(setMailchimpSettings(response));

        return;
      }

      dispatch(setMailchimpSettings(response));
      dispatch(setMailchimpSettingsState());
    }).catch((error) => {
      getMailchimpSettingsError();

      Logger.error('Fetch mailchimp sync settings', {
        error,
        action: 'Fetch mailchimp sync settings',
      });
    });
};
